module.exports = __webpack_public_path__ + "static/img/numbers_bg_porting.3654878d.png";